export default {
  contact: {
    padding: '20px 0',
    border: 'none',
    boxShadow: 'none',
    maxItem: 4
  }
};
